import { ComponentType } from 'react';

import { PrimaryMarket } from './PrimaryMarket';
import { SecondaryMarket } from './SecondaryMarket';
import { MarketKey, resolveMarketKey } from '../market';

// ─── Types ────────────────────────────────────────────────────────────────────

type SectionComponent = ComponentType<{ id: string }>;

// ─── Registry structure ───────────────────────────────────────────────────────
// market (exact string from URL params) -> section title -> subsection title? -> Component
//
// Sections WITHOUT subsections use the key '_root_' as subsection.
// Sections WITH subsections use the subsection title as key.
//
// To add a new market, add a new top-level entry here.
// To add a new section for an existing market, add it inside its entry.

type SubsectionMap = Record<string, SectionComponent>;
type SectionMap = Record<string, SubsectionMap>;
type MarketRegistry = Partial<Record<MarketKey, SectionMap>>;

const registry: MarketRegistry = {
  fidc: {
    Mercado: {
      Primário: PrimaryMarket,
      Secundário: SecondaryMarket,
    },
  },
  crs: {
    Mercado: {
      Primário: PrimaryMarket,
      Secundário: SecondaryMarket,
    },
  },
  fii: {
    Mercado: {
      Primário: PrimaryMarket,
      Secundário: SecondaryMarket,
    },
  },
  // FIAGRO: { Mercado: { Primário: FiagroPrimaryMarket, ... } },
};

// ─── Lookup helpers ───────────────────────────────────────────────────────────

/**
 * Returns the registered component for a section WITH subsections,
 * or null if none is registered for the current market.
 */
export function getSubsectionComponent(
  market: string | undefined,
  sectionTitle: string,
  subsectionTitle: string,
): SectionComponent | null {
  const marketKey = resolveMarketKey(market);

  if (!marketKey) {
    return null;
  }

  return registry[marketKey]?.[sectionTitle]?.[subsectionTitle] ?? null;
}
